<template>
  <div class="multimedia">
    <div class="multimedia-card">
      <figure class="multimedia-visual">
          <img
            v-if="multimedia.picture"
            :src="multimedia.picture.src2x"
            :alt="multimedia.picture.alt"
          >
          <img
            v-else
            src="@/assets/images/event-default.jpg"
          />
          <button @click="openVideo">
            <span class="u-visually-hidden">Lire le média</span>
            <sprite
              :type="'multimedia-play'"
              :width="47"
              :height="47"
            />
          </button>
      </figure>
      <div class="multimedia-content">
        <p class="multimedia-categories">
          <span v-for="(cat, index) in multimedia.categories"
                :key="`${cat.id}-${index}`">
                {{ cat.name }}
          </span>
        </p>
        <h3 class="multimedia-title h1" v-html="multimedia.title" />
      </div>
    </div>

    <div v-if="isOpen" class="multimedia-popup">
      <div class="multimedia-popup-wrapper">
        <div class="multimedia-popup-inner" v-html="multimedia.media_video" />
      </div>
      <button
        class="multimedia-popup-close"
        @click="openVideo"
      >
        <sprite
          class="svg"
          :type="'close'"
          :width="14"
          :height="14"
        />
      </button>
    </div>
  </div>
</template>

<script>
import Sprite from '@/components/components/Sprite.vue';

export default {
  components: {
    Sprite
  },
  props: {
    multimedia: {
      type: Object
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {

  },
  methods: {
    openVideo() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
  .multimedia {
    margin-top: 10px;

    &-visual {
    @include aspect-ratio(336, 173);
    width: 100%;
    background-color: $grey;
    line-height: 0;
    font-size: 0;
      img {
        @include position(absolute, 0 0 0 0);
        @include size(100%);
        object-fit: cover;
      }

      button {
        @include position(absolute, 0 0 0 0);
        @include size(100%);
      }
    }
    &-content {
      padding: 20px;
      margin: 0 0 20px;
      background-color: $black-light;
    }
    &-categories {
      margin: 0 0 15px;
      span {
        + span {
          margin-left: 10px;
        }
      }
    }

    &-popup {
    @include position(fixed, 0 null null 0);
    @include size(100%);
    z-index: 1003;

      &-wrapper {
        @include position(absolute, 50% null null 50%);
        @include size(100%);
        @include padding(10px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 1;
        transform: translate(-50%, -50%);
        background-color: $black;
      }

      &-inner {
        @include aspect-ratio(16,9);
        max-height: 90vh;
        width: 100%;
      }

      &-close {
        @include size(40px);
        @include position(absolute, 20px 20px null null);
        z-index: 1;
        background-color: $primary;
        border-radius: 6px;

        .svg {
          fill: $white;
        }
      }
    }
  }

</style>
